import { css, html } from "lit";
import { attributeProperty } from "../../property.js";
import type { ParserType } from "../../schemas/parser.js";
import { Size as SizeSchema } from "../../schemas/size.js";
import { hostStyles } from "../../styles/host.styles";
import sizeStyles from "../../styles/size.styles";
import { WmElement } from "../element";

type Size = ParserType<typeof Size>;
const Size = attributeProperty("size", SizeSchema.schema, {
  defaultValue: "m",
});

export class WmDeleteButton extends WmElement {
  static readonly TAG_NAME = "wm-delete-button";

  static styles = [
    hostStyles,
    sizeStyles,
    css`
      wa-icon {
        color: var(--wa-color-danger)
      }
    `,
  ];

  static properties = {
    size: Size,
    // TODO: need to implement overrides in property factories for that.
    asIcon: { attribute: "as-icon", reflect: true, type: Boolean },
  };

  declare readonly asIcon: boolean;
  declare readonly size: Size;

  protected override render(): unknown {
    if (this.asIcon) {
      return this.#renderAsIcon();
    } else {
      return this.#renderAsButton();
    }
  }

  #renderAsButton() {
    return html`<wa-button variant="danger" size=${this.size}>Delete</wa-button>`;
  }

  // TODO: could make the on hover transparent.
  #renderAsIcon() {
    return html`
      <wa-button appearance="plain" size=${this.size}>
        <wa-icon name="trash"></wa-icon>
      </wa-button>
      `;
  }
}

customElements.define(WmDeleteButton.TAG_NAME, WmDeleteButton);

declare global {
  interface HTMLElementTagNameMap {
    [WmDeleteButton.TAG_NAME]: WmDeleteButton;
  }
}
